import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { siteData } from "../mock";

export default function Hero() {
  const { primaryPhone, primaryPhoneRaw, whatsapp } = siteData.brand;
  const { hero } = siteData;
  return (
    <section className="relative min-h-[88svh] flex items-center overflow-hidden bg-[#0b1424]">
      <div className="absolute inset-0">
        <img src={hero.image} alt="Premium property in Tricity" className="w-full h-full object-cover opacity-[0.55]" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0b1424]/92 via-[#0b1424]/70 to-[#0b1424]/88" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b1424] via-transparent to-[#0b1424]/60" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-10 w-full py-14 md:py-24">
        <div className="max-w-3xl">
          <div className="text-[10.5px] md:text-[11px] tracking-[0.3em] text-[#c6a071] mb-5 uppercase">{hero.kicker}</div>
          <h1 className="font-serif text-white text-[44px] leading-[1.05] sm:text-[56px] md:text-[78px] md:leading-[1.02] tracking-tight">
            {hero.title1}{" "}
            <span className="italic text-[#c6a071] block md:inline">{hero.titleAccent}</span>
          </h1>
          <p className="mt-6 md:mt-7 text-white/80 text-[16px] md:text-[20px] leading-relaxed">{hero.sub}</p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4 max-w-lg">
            <a href={`tel:${primaryPhoneRaw}`} className="btn-gold inline-flex items-center justify-center gap-2 px-7 py-4 text-[14px] tracking-wide font-medium w-full sm:w-auto">
              <Phone className="w-4 h-4" /> Call Now · {primaryPhone}
            </a>
            <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer" className="btn-outline-light inline-flex items-center justify-center gap-2 px-7 py-4 text-[14px] tracking-wide w-full sm:w-auto">
              WhatsApp Now <ArrowRight className="w-4 h-4" />
            </a>
          </div>

          <div className="mt-12 md:mt-16 flex items-center gap-5">
            <div className="h-[1px] w-10 md:w-14 bg-[#c6a071]" />
            <div className="text-white/85 text-[13px] md:text-[14px]">{hero.footer}</div>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link to="/properties" className="text-white/80 hover:text-[#c6a071] inline-flex items-center gap-2 text-[13.5px] tracking-wide transition-colors">Browse Properties <ArrowRight className="w-4 h-4" /></Link>
            <span className="text-white/25 mx-1">|</span>
            <Link to="/contact" className="text-white/80 hover:text-[#c6a071] inline-flex items-center gap-2 text-[13.5px] tracking-wide transition-colors">Talk to a Consultant</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
